import { SelectOption } from '@/const/types'

export type SelectOptionWithDescription = SelectOption & { description?: string }

export const memberRoles = {
	admin: 'Edit access to Scheduling Template and Appointment Board',
	standard: 'View access to Scheduling Template and Appointment Board'
}

export const accessOptions: SelectOptionWithDescription[] = [
	{
		label: 'Admin',
		value: 'admin',
		description: memberRoles.admin
	},
	{
		label: 'Standard',
		value: 'standard',
		description: memberRoles.standard
	}
]
